import { AccUpgradeState } from './index';
import { MutationTree } from 'vuex';

export default {
    setAvailableUpgrades(state: AccUpgradeState, availableAccUpgrades) {
        state.availableAccommodationUpgrades = availableAccUpgrades;
    },
    initAccommodationUpgrades(state: AccUpgradeState, days) {
        state.accommodationUpgrades = days;
    },
    setAccommodationUpgrades(state: AccUpgradeState, [key, accommodationUpgrade]) {
        // @ts-ignore
        state.accommodationUpgrades[key] = accommodationUpgrade;
    },
    resetAccoUpgrades(state: AccUpgradeState) {
        state.accommodationUpgrades = {};
    }
} as MutationTree<AccUpgradeState>
